import { K8sProviderIcon } from '@cast/features-cluster-ui';

import { HexIcon, Typography, Stack } from '@cast/design-system';
import { Cluster } from '@cast/types';

type ConnectedStateProps = {
  cluster?: Cluster;
  reconnect?: boolean;
};

export const ConnectedState = ({ cluster, reconnect }: ConnectedStateProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={12}
      data-testid="connected-state"
    >
      <HexIcon
        variant="success"
        display="flex"
        alignSelf="flex-start"
        size={44}
        animationType="pulsateSlow"
      />

      <Typography variant="h6" display="inline">
        Great!{' '}
        {cluster?.providerType && (
          <K8sProviderIcon
            provider={cluster.providerType}
            size={24}
            style={{ verticalAlign: 'middle' }}
          />
        )}{' '}
        {cluster?.name} {reconnect ? 'reconnected' : 'connected'} successfully!
      </Typography>
    </Stack>
  );
};
